/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Work_0_DescInputs */

const en_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every answer grounded in the curriculum via RAG, streamed fast and cost-controlled per session.`)
};

const ar_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل إجابة مؤسسة في المنهج عبر RAG، تبث بسرعة وبتكلفة مضبوطة لكل جلسة.`)
};

const bn_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG-এর মাধ্যমে পাঠ্যক্রমে ভিত্তি প্রতিটি উত্তর, দ্রুত প্রবাহিত আর প্রতি সেশনে খরচ-নিয়ন্ত্রিত।`)
};

const de_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Antwort im Lehrplan via RAG fundiert, schnell gestreamt und pro Sitzung kostenkontrolliert.`)
};

const es_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada respuesta fundamentada en el plan de estudios vía RAG, transmitida rápido y con coste controlado por sesión.`)
};

const fr_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque réponse ancrée dans le programme via RAG, diffusée vite et à coût contrôlé par session.`)
};

const pt_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada resposta fundamentada no plano de estudos via RAG, transmitida rápido e com custo controlado por sessão.`)
};

const zh_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个回答都基于课程 RAG 有据可查，传输快，每会话成本可控。`)
};

const tr_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her yanıt RAG ile müfredata dayalı, hızlı akar, oturum başına maliyet kontrollü.`)
};

const ru_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый ответ обоснован программой через RAG, стримится быстро и с контролируемой ценой за сессию.`)
};

const pl_svc_rag_knowledge_assistants_work_0_desc = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każda odpowiedź ugruntowana w programie przez RAG, streamowana szybko i z kosztem kontrolowanym na sesję.`)
};

/**
* | output |
* | --- |
* | "Every answer grounded in the curriculum via RAG, streamed fast and cost-controlled per session." |
*
* @param {Svc_Rag_Knowledge_Assistants_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_work_0_desc = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_work_0_desc(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_work_0_desc(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_work_0_desc(inputs)
	return en_svc_rag_knowledge_assistants_work_0_desc(inputs)
});
export { svc_rag_knowledge_assistants_work_0_desc as "svc_rag-knowledge-assistants_work_0_desc" }